'use client';
import { logger } from '#pplx/frontend/logger/browser.js';
import { createContext, useContext } from 'react';
export const initialQueryState = {
    submitQuery: (_params) => {
        logger.error('submitQuery must be used within AskQueryStateProvider');
        return false;
    },
    quote: null,
    setQuote: (_quote) => void 0,
    updateLocalStatePostStream: (_message) => void 0,
    submissionQueryCount: 0,
};
export const PplxQueryStateContext = createContext(initialQueryState);
PplxQueryStateContext.displayName = 'PplxQueryStateContext';
export const usePerplexityQueryState = () => {
    const ctx = useContext(PplxQueryStateContext);
    if (!ctx)
        throw new Error('usePerplexityQueryState must be used within AskQueryStateProvider');
    return ctx;
};
//# sourceMappingURL=usePerplexityQueryState.js.map